const state = () => ({timeStage1: 10000, timeWrite: 40, timeStage2: 5000, timeout: 1000, bolota: '3s', speed: false, play: true })
const mutations = {
  speed(state){
    state.timeStage1 = 500
    state.timeWrite = 1
    state.timeStage2 = 5
    state.timeout = 95
    state.bolota = "0.1s"
    state.speed = true
  },
  normal(state){
    state.timeStage1 = 10000
    state.timeWrite = 40
    state.timeStage2 = 5000
    state.timeout = 1000
    state.bolota = '3s'
    state.speed = false
  },
  togglePlay(state, value){
    state.play = value
  }
}
export default { state, mutations, namespaced: true }